const isLocal =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

const BASE_URL = isLocal
  ? "http://localhost:5202"          // 👈 your local backend
  : "https://smsserver.nsfdcdigital.in";

export const CONFIG = {
  API_BASE: `${BASE_URL}/api/Bsnl`,
  DB_BASE: `${BASE_URL}/api/Db`,
  AUTH_BASE: `${BASE_URL}/api/Auth`,
  TIMEOUT: 45000,
  RETRY_LIMIT: 3
};

export const VALIDATION = {
  MOBILE: /^[6-9]\d{9}$/,
  TEMPLATE_ID: /^\d{10,20}$/,
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  SCIENTIFIC_NOTATION: /[+-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+-]?\d+)/
};
